import { createSlice } from "@reduxjs/toolkit";
import {
  // deletePeople,
  // editPeople,
  // getPeopleById,
  // getPeopleList,
  getPeoplePage,
  // postPeople,
  // getPeopleByRegionalId,
} from "../action/peopleAction";

const initialState = {
  dataPeople: [],
  dataByIdPeople: [],
  dataPeopleByRegionalId: [],
  idPeople: "",
  state: "",
  isOpenForm: false,
  isLoading: false,
  isOpenPDF: false,
};
const peopleSlice = createSlice({
  name: "people",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.type === 'close') {
        state.dataByIdPeople = []
        state.idPeople = ''
      }
      if (action.payload.state === "edit") {
        state.dataByIdPeople = action.payload.data;
        state.idPeople = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdPeople = action.payload.data;
        state.idPeople = action.payload.id;
      }
    },
    openPDF: (state, action) => {
      state.isOpenPDF = action.payload.open
    },
  },
  extraReducers: {
    [getPeoplePage.pending]: (state) => {
      state.isLoading = true;
    },
    [getPeoplePage.fulfilled]: (state, action) => {
      // console.log(action.payload.data.content);
      state.dataPeople = action.payload.data;
      state.isLoading = false;
    },
    [getPeoplePage.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { openForm, openPDF } = peopleSlice.actions;
export default peopleSlice.reducer;
